var React = require('react');

function TableViewSmall (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10 0H2A1.966 1.966 0 00.59.59 1.966 1.966 0 000 2v8a1.966 1.966 0 00.59 1.41A1.983 1.983 0 002 12h8a2.015 2.015 0 002-2V2a1.966 1.966 0 00-.59-1.41A2.025 2.025 0 0010 0zM7 2v2H2V2zm0 5H2V5h5zM2 8h5v2H2zm6 2V2h2v8z","key":0}),React.createElement("path",{"fill":"none","d":"M0 0h12v12H0z","key":1})]);
}

TableViewSmall.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","className":"css-1s665wz"};

module.exports = TableViewSmall;

TableViewSmall.default = TableViewSmall;
